<template>
  <header>
    <div class="c-nav__block">
      <button
        class="c-gnav__button"
        type="button"
        name="button"
        @click="show"
      ><img
          src="/assets/image/kitty_y.png"
          alt="menu"
        />
        <span class="c-gnav__button-item">menu</span>
      </button>
      <div class="c-panel c-nav__panel">
        <div class="c-nav__tit-block">
          <h1 class="c-nav__tit">{{ title }}</h1>
          <router-link
            to="/"
            class="c-nav__home"
          ><i class="fas fa-home"></i></router-link>
        </div>
        <div class="c-nav__body">

          <transition name="right">
            <nav
              class="c-gnav"
              v-if="gnav"
            >

              <ul class="c-gnav__list">
                <li
                  class="c-gnav__item"
                  @click="show"
                >
                  <router-link
                    class="c-gnav__link"
                    to="/"
                  >home</router-link>
                </li>
                <li
                  class="c-gnav__item"
                  @click="show"
                >
                  <router-link
                    class="c-gnav__link"
                    to="/profile"
                  >profile</router-link>
                </li>
                <li
                  class="c-gnav__item"
                  @click="show"
                >
                  <router-link to="/skills">skills</router-link>
                </li>
                <li
                  class="c-gnav__item"
                  @click="show"
                >
                  <router-link to="/works">works</router-link>
                </li>
                <li
                  class="c-gnav__item"
                  @click="show"
                >
                  <a href="/contact">contact</a>
                </li>
              </ul>

            </nav>
          </transition>
          <nav class="c-nav">

            <ul class="c-nav__list">
              <li class="c-nav__item">
                <router-link
                  class="c-nav__link"
                  to="/profile"
                >profile</router-link>
              </li>
              <li class="c-nav__item">
                <router-link to="/skills">skills</router-link>
              </li>
              <li class="c-nav__item">
                <router-link to="/works">works</router-link>
              </li>
              <li class="c-nav__item">
                <router-link to="/contact">contact</router-link>
              </li>
            </ul>

          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Nav",
  props: {
    title: String
  },
  data() {
    return {
      gnav: false
    };
  },
  methods: {
    show() {
      this.gnav = !this.gnav;
    }
  }
};
</script>

<style  lang="scss">
.c-gnav
{
    &__button
    {
        display: none;
        @media only screen and (max-width: 768px)
        {
            display: block;
        }
    }
}

@media only screen and (max-width: 768px)
{
    .c-gnav
    {
        position: fixed;
        z-index: 10;
        top: 0;
        right: 0;

        width: 100%;
        height: 100%;

        background-color: white;

        &__list
        {
            padding: 160px 0;
        }

        &__item
        {
            font-size: 2rem;

            display: block;

            text-align: center;

            &:nth-child(n + 2)
            {
                margin-top: 40px;

                border: none;
            }
        }

        &__button
        {
            position: fixed;
            z-index: 100;
            top: 15px;
            right: 20px;

            display: block;

            width: 50px;
            height: 50px;

            cursor: pointer;

            border: none;
            outline: none;
            background-color: transparent;

            appearance: none;

            &:active
            {
                animation: anim-scale .5s ease-out;
            }

            &-item
            {
                font-family: 'Alegreya Sans SC', YuGothic, 'Yu Gothic Medium',
                'Yu Gothic', Verdana, Meiryo, sans-serif;
                font-size: 1.6rem;

                position: absolute;
                left: 50%;

                display: block;

                transition: .5s ease;
                transform: translateX(-50%);

                color: #666360;
            }
        }
    }

    @keyframes anim-scale
    {
        0%
        {
            transform: scale(.4, .4);
        }
        40%
        {
            transform: scale(1.2, 1.2);
        }
        60%
        {
            transform: scale(1, 1);
        }
        80%
        {
            transform: scale(1.1, 1.1);
        }
        100%
        {
            transform: scale(1, 1);
        }
    }

    .right-enter-active,
    .right-leave-active
    {
        transition: transform 225ms cubic-bezier(0, 0, .2, 1) 0ms;
        transform: translate(0px, 0px);
    }
    .right-enter,
    .right-leave-to
    {
        transform: translateX(100vw) translateX(0px);
    }
}

</style>
